import { render } from "./New.vue?vue&type=template&id=b623e058&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"

import "./New.vue?vue&type=style&index=0&id=b623e058&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b623e058"

export default script